import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './style.sass';
import { Children, memo } from 'react';
export const AllMapButtons = memo(function AllMapButtons(props) {
    const { upChild, leftChild } = props;
    return (_jsxs("div", { className: "ui-map-button-container", children: [_jsx("div", { className: "up-buttons", children: Children.map(upChild, (child, index) => (_jsx("div", { className: "up-button", children: child }, index))) }), _jsx("div", { className: "left-buttons", children: Children.map(leftChild, (child, index) => (_jsx("div", { className: "left-button", children: child }, index))) })] }));
});
